import { render } from "./form1.vue?vue&type=template&id=1ce268aa&scoped=true&ts=true"
import script from "./form1.vue?vue&type=script&lang=ts"
export * from "./form1.vue?vue&type=script&lang=ts"

import "./form1.vue?vue&type=style&index=0&id=1ce268aa&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce268aa"]])

export default __exports__